import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {TeamIssueSelectors} from "@team/pages/issues/store/team-issue.selector-type";

@Injectable({
  providedIn: 'root'
})
export class TeamIssueReadGuard {
  private _store = inject(Store);
  private _router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._store.pipe(
      withLatestFrom(this._store.select(TeamIssueSelectors.selectDetailDataFormatted)),
      map(([_, formattedData]) => {

        if (Object.keys(formattedData).length === 0) {
          return this._router.createUrlTree(['team/logged/issues']);
        } else {
          return true;
        }
      })
    );
  }
}
